import styled from "styled-components";
import { Card } from "antd";
import { EaseDrawer } from "../../libs/EaseDrawer";

export const InfoCard = styled(Card)`
    border-radius: 10px !important;
    width: max-content;
    box-shadow: 2px 2px 5px 0px #ddd !important;
`;

export const SplitAccDrawer = styled(EaseDrawer)`
    /* .ant-drawer-body {
        height: 100%;
    } */

    .ant-drawer-header {
        position: sticky;
        top: 0;
        z-index: 999;
    }

.priority-input{
    width: 100px;
}

.rest-of-amt-text{
    font-style: italic;
}
`;
